export default __webpack_public_path__ + "static/media/tpblogo.00383518.png";